export default class ToggleSelect {
  constructor(toggles, items, bg, extras) {
    this.toggles = document.querySelectorAll(`.${toggles}`);
    this.items = document.querySelectorAll(`.${items}`);
    this.bg = document.querySelector(`.${bg}`);
    this.extras = document.querySelectorAll(`.${extras}`);

    if (this.toggles.length && this.items.length && this.bg) this.init();
  }

  /**
   * Remove all active classes ('is-active') from the supplied array of elements.
   * @param elms - The array of elements to remove the class from.
   */
  removeAllActiveClasses(elms) {
    elms.forEach((type) => type.classList.remove('is-active'));
  }

  /**
   * If an array is supplied, add the active class to each element in the array.
   * If one element is supplied, add the active class to the single element.
   * @param elms - The element(s) to which to add the active class.
   */
  addActiveClass(elms) {
    elms.length > 1
      ? elms.forEach((elm) => elm.classList.add('is-active'))
      : elms.classList.add('is-active');
  }

  /**
   * Sets the width of the BG style element
   * @param target - The target element to set the BG's width to match.
   */
  setBgWidth(target) {
    this.bg.style.width = `${target.offsetWidth}px`;
  }

  /**
   * Sets the translateX position of the BG style element to be the same as the width of first target element,
   * or 0 if the target is the first item.
   * @param index - The index of the clicked item, related to the toggles array.
   * @param target - The target element to set the BG's translateX position to match.
   */
  setBgTransform(index, target) {
    index === 1
      ? (this.bg.style.transform = `translateX(${this.toggles[0].offsetWidth}px)`)
      : (this.bg.style.transform = 'translateX(0)');
  }

  /**
   * The click event of the finance toggle buttons.
   * @param e - The clicked toggle button.
   * @param index - The index of the clicked item, related to the toggles array.
   */
  toggleClickEvent(e, index) {
    const target = e.target;

    this.setBgWidth(target);
    this.setBgTransform(index, target);

    this.removeAllActiveClasses([...this.toggles, ...this.items, ...this.extras]);

    this.addActiveClass(target);

    this.items.forEach((item) =>
      item.dataset.type === target.dataset.type ? this.addActiveClass(item) : null,
    );
    this.extras.forEach((extra) =>
      extra.dataset.type === target.dataset.type ? this.addActiveClass(extra) : null,
    );
  }

  init() {
    //Set the initial width of the BG to equal the first (default) item.
    this.setBgWidth(this.toggles[0]);
    [...this.toggles].forEach((type, index) =>
      type.addEventListener('click', (e) => this.toggleClickEvent(e, index)),
    );
  }
}
